import { DateStringValue } from '@unistocks/components/calendar/types';
import { createDate } from '@unistocks/shared/utils/util';

interface IsMonthDisabledInput {
  month: DateStringValue;
  minDate: DateStringValue | undefined;
  maxDate: DateStringValue | undefined;
}

/** Whether `month` falls outside the `[minDate, maxDate]` bounds (month granularity). */
export function isMonthDisabled({ month, minDate, maxDate }: IsMonthDisabledInput): boolean {
  if (!minDate && !maxDate) {
    return false;
  }

  if (minDate && createDate(month).startOf('month') < createDate(minDate).startOf('month')) {
    return true;
  }

  if (maxDate && createDate(month).startOf('month') > createDate(maxDate).startOf('month')) {
    return true;
  }

  return false;
}
